.dialog {
  min-width: 424px;
  overflow-x: hidden;
  padding-top: var(--pgm-sys-spacing-4);
}

.header {
  padding: var(--pgm-sys-spacing-0) var(--pgm-sys-spacing-0) var(--pgm-sys-spacing-4);
}

.body {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
}

.summary {
  display: grid;
  gap: var(--pgm-sys-spacing-3);
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.summaryItem {
  background-color: var(--pgm-sys-color-surface-container-highest);
  border-radius: var(--pgm-sys-spacing-2);
  color: var(--pgm-sys-color-on-surface-variant);
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: var(--pgm-sys-spacing-2) var(--pgm-sys-spacing-3);
}

.summaryValue {
  color: var(--pgm-sys-color-on-surface-variant);
}

.notice {
  align-items: center;
  background-color: var(--pgm-sys-color-info-container);
  border-radius: var(--pgm-sys-spacing-2);
  color: var(--pgm-sys-color-on-info-container);
  display: flex;
  gap: var(--pgm-sys-spacing-2);
  padding: var(--pgm-sys-spacing-2);

  > span:first-child {
    flex-shrink: 0;
    font-size: 18px;
    line-height: 1;
  }
}

.paymentInstructions {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
}

.steps,
.pix {
  min-width: 0;
  padding: var(--pgm-sys-spacing-1) var(--pgm-sys-spacing-4);
}

.steps {
  border-right: 1px solid var(--pgm-sys-color-outline-variant);
  padding-left: 0;
  padding-right: var(--pgm-sys-spacing-5);
}

.pix {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-left: var(--pgm-sys-spacing-5);
  padding-right: 0;
  text-align: center;
}

.sectionTitle {
  color: var(--pgm-sys-color-on-surface);
  margin: 0 0 var(--pgm-sys-spacing-2);
}

.pixDescription {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0 0 var(--pgm-sys-spacing-2);
}

.stepsList {
  color: var(--pgm-sys-color-on-surface-variant);
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  margin: 0;
  padding-left: var(--pgm-sys-spacing-5);
}

.qrCode {
  align-items: center;
  background-color: var(--pgm-sys-color-surface-container-lowest);
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: var(--pgm-sys-spacing-1);
  box-sizing: border-box;
  display: flex;
  height: 128px;
  justify-content: center;
  padding: var(--pgm-sys-spacing-1);
  width: 128px;

  img {
    display: block;
    height: 100%;
    object-fit: contain;
    width: 100%;
  }
}

.or {
  align-items: center;
  color: var(--pgm-sys-color-on-surface-variant);
  display: flex;
  gap: var(--pgm-sys-spacing-2);
  margin: var(--pgm-sys-spacing-2) 0;
  width: 100%;

  &::before,
  &::after {
    background-color: var(--pgm-sys-color-outline-variant);
    content: "";
    flex: 1;
    height: 1px;
  }
}

.pixCode {
  align-items: center;
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: var(--pgm-sys-spacing-2);
  box-sizing: border-box;
  color: var(--pgm-sys-color-on-surface-variant);
  display: flex;
  gap: var(--pgm-sys-spacing-2);
  padding: var(--pgm-sys-spacing-2) var(--pgm-sys-spacing-3);
  text-align: left;
  width: 100%;

  > span:first-child {
    flex: 1;
    min-width: 0;
    overflow-wrap: anywhere;
  }
}

.copyIcon {
  font-variation-settings: "FILL" 1;
}

@media (max-width: 600px) {
  .dialog {
    min-width: 0;
  }

  .summary,
  .paymentInstructions {
    grid-template-columns: 1fr;
  }

  .steps {
    border-bottom: 1px solid var(--pgm-sys-color-outline-variant);
    border-right: 0;
    padding: 0 0 var(--pgm-sys-spacing-4);
  }

  .pix {
    padding: var(--pgm-sys-spacing-4) 0 0;
  }
}
